import { render, staticRenderFns } from "./SerpToolbarMenu.vue?vue&type=template&id=cbbb5ac8&scoped=true"
import script from "./SerpToolbarMenu.vue?vue&type=script&lang=js"
export * from "./SerpToolbarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbb5ac8",
  null
  
)

export default component.exports